// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input[data-v-742f9e3c]{padding-top:0!important}.v-list__tile__mask[data-v-742f9e3c]:deep(){background:pink!important;color:#000!important;font-weight:600}", ""]);
// Exports
module.exports = exports;
